import React from "react";
import { Card, Grid, Box, Typography } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  title: {
    fontSize: "18px !important",
    fontWeight: "700 !important",
    lineHeight: "22px",
    textAlign: "start",
  },
  description: {
    fontSize: "14px !important",
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    color: "#555",
  },
  thumbnailContainer: {
    position: "relative",
    width: "100%",
    height: "100%",
    overflow: "hidden",
    cursor: "pointer",
    borderRadius: "8px",
  },
  thumbnail: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
    borderRadius: "8px",
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "8px",
  },
  playIcon: {
    color: "#fff",
    fontSize: "48px",
  },
  cardContainer: {
    display: "flex",
    height: "150px",
    border: "1px solid #ddd",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    padding: "10px",
  },
  cardContent: {
    height: "100%",
    padding: "0 10px",
  },
}));

const TutorialCard = ({ videoUrl, title, description }) => {
  const classes = useStyles();

  const getVideoId = (url) => {
    const urlParams = new URLSearchParams(new URL(url).search);
    return urlParams.get("v");
  };

  const videoId = getVideoId(videoUrl);
  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;

  const handleView = () => {
    window.open(videoUrl, "_blank");
  };

  return (
    <Card className={classes.cardContainer}>
      <Grid container sx={{ height: "100%", margin: "0px" }}>
        <Grid
          item
          xs={4}
          className={classes.thumbnailContainer}
          onClick={handleView}
        >
          <img
            src={thumbnailUrl}
            alt={title}
            className={classes.thumbnail}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = `https://img.youtube.com/vi/${videoId}/0.jpg`;
            }}
          />
          <Box className={classes.overlay}>
            <PlayArrowIcon className={classes.playIcon} />
          </Box>
        </Grid>

        <Grid item xs={8}>
          <Box className={classes.cardContent}>
            <Typography className={classes.title}>{title}</Typography>
            <Typography className={classes.description}>
              {description}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Card>
  );
};

export default TutorialCard;
